module.exports = __webpack_public_path__ + "img/knife_back_show.5e255260.png";